// extracted by mini-css-extract-plugin
export default {"root":"image-editor-dialg_root__-Wi5-","dialog-content-root":"image-editor-dialg_dialog-content-root__clrvA"};